<ng-content></ng-content>
  <ng-template ngFor let-diaText [ngForOf]="dialogText" let-i="index">
    <div *ngIf="diaText != ''" class="markdown-description" [innerHTML]="diaText"  (click)="interceptClick($event)"></div>
    <iframe *ngIf="audioUrl[i] !== undefined && audioUrl[i] != null && loadAudio" class="player" name= "player" [src]="audioUrl[i]">
    </iframe>
    <iframe *ngIf="videoUrl[i] !== undefined && videoUrl[i] != null && loadVideo" class="video" name="vplayer" [src]="videoUrl[i]" frameborder="0" allow="accelerometer; encrypted-media; gyroscope;" allowfullscreen>
    </iframe>
  </ng-template>
